/**
 * Form label focus, select2 + other stuff
 *
 * @since   1.0.0
 * @package blujay
 */

(function($) {
  $(document).ready(function() {
    //stuff
    var inputs = $('input[type=\'text\'],input[type=\'tel\'],input[type=\'email\']');
    // var selects = $('form:not( .filters ) select[\'multiple\']');
    // var filterSelects = $('form.filters select[\'multiple\']');
    // var select2Options = [];

    //bind stuff
    //set classes for input labels
    inputs.on('focus', function() {
      $(this).prev('label').addClass('focused');
    });
    inputs.on('blur', function() {
      $(this).prev('label').removeClass('focused');
    });

    //select2 stuff

    // select2Options = {
    //   minimumResultsForSearch: Infinity,
    //   width: '250px',
    // };

    // selects.select2(select2Options);

    // // override select2 for filter form
    // filterSelects.select2({
    //   minimumResultsForSearch: Infinity,
    //   dropdownCssClass: 'filters',
    //   width: '100%',
    // });

    //turn off autocomplete for data picker
    $('.date-picker').on('click', function(e) {
      e.preventDefault();
      $(this).attr('autocomplete', 'off');
    });
    $('.date-picker').each(function(){
      $(this).attr('autocomplete', 'off');
  });

  }); // document.ready
})(jQuery);
